export const POPULAR_SERVICE_SLUGS = [
  'crm-implementation',
  'website-development',
  'website-design',
  'paid-advertising',
  'full-inbound-marketing-services',
  'content-creation',
  'sales-enablement',
  'email-marketing',
];

export const INITIAL_POPULAR_COUNT = 5;

export const POPULAR_INDUSTRY_SLUGS = [
  'consulting-advisory',
  'banking-financial-services',
  'construction-and-renovation',
  'real-estate',
  'technology',
  'healthcare',
  'education',
  'retail',
];

export const INITIAL_POPULAR_INDUSTRY_COUNT = 4;
